/*
  Kiwi Ears · Become a Dealer page (Rene 2026-08-31) — sections/dl-fit,
  dl-planner, dl-apply.

  IT TOGGLES SERVER-RENDERED MARKUP, IT NEVER BUILDS A PANEL. Every partner
  panel, planner card, and form step is Liquid; this file decides what shows.
  The two derived surfaces are legitimate derivations of the visitor's own
  input: the fit-check result copies text from the chosen panel's data
  attributes, and the review step summarises what the visitor typed, using
  the labels already rendered next to each field.

  The application form is Shopify's real contact form. Without this file it
  renders as one long form and still submits; arming the stepper here hides
  steps, shows the progress rail and review step, takes over validation
  (form.noValidate), mirrors the checkbox groups into hidden contact[...]
  fields, and keeps a draft in localStorage — which also repopulates the
  custom contact[...] fields after a server-side validation error, since
  Shopify only re-fills name/email/body on that re-render. The draft clears
  when the success block renders.
*/
(function () {
  'use strict';
  if (window.__kiwiDealer) return;
  window.__kiwiDealer = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------- program fit: partner workbench ---------------- */
  var fit = $('[data-dl-fit]');
  if (fit) {
    var tabs = $$('[data-dl-tab]', fit);
    var panels = $$('[data-dl-partner]', fit);

    var selectPartner = function (key, pushUrl) {
      var panel = null;
      panels.forEach(function (p) {
        var on = p.getAttribute('data-dl-partner') === key;
        p.hidden = !on;
        if (on) panel = p;
      });
      if (!panel) return;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-dl-tab') === key;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      if (pushUrl && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('path', key);
          history.replaceState(null, '', u.pathname + u.search + u.hash);
        } catch (_) { /* URL API missing: the tab still works */ }
      }
    };

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectPartner(t.getAttribute('data-dl-tab'), true); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus();
        selectPartner(n.getAttribute('data-dl-tab'), true);
      });
    });

    try {
      var fromUrl = new URL(window.location.href).searchParams.get('path');
      if (fromUrl) selectPartner(fromUrl, false);
    } catch (_) {}

    /* ---------------- fit check ---------------- */
    var result = $('[data-dl-fitresult]', fit);
    if (result) {
      var nameEl = $('[data-dl-fitname]', result);
      var copyEl = $('[data-dl-fitcopy]', result);
      var useBtn = $('[data-dl-usefit]', result);
      var emptyName = nameEl.textContent;
      var emptyCopy = copyEl.textContent;
      var picked = '';

      var mapFit = function (place, role) {
        if (role === 'wholesale' || place === 'network') return 'distributor';
        if (role === 'solution' || place === 'specialist') return 'specialist';
        if (place === 'store') return 'retail';
        return 'online';
      };
      var panelFor = function (key) {
        return panels.filter(function (p) { return p.getAttribute('data-dl-partner') === key; })[0] || null;
      };

      var updateFit = function () {
        var place = (fit.querySelector('input[name="dl-place"]:checked') || {}).value;
        var role = (fit.querySelector('input[name="dl-role"]:checked') || {}).value;
        if (!place || !role) {
          picked = '';
          nameEl.textContent = emptyName;
          copyEl.textContent = emptyCopy;
          useBtn.disabled = true;
          return;
        }
        picked = mapFit(place, role);
        var panel = panelFor(picked);
        if (!panel) { picked = ''; useBtn.disabled = true; return; }
        nameEl.textContent = panel.getAttribute('data-form-value') || '';
        copyEl.textContent = panel.getAttribute('data-summary') || '';
        useBtn.disabled = false;
      };

      $$('input[name="dl-place"], input[name="dl-role"]', fit).forEach(function (r) {
        r.addEventListener('change', updateFit);
      });

      useBtn.addEventListener('click', function () {
        if (!picked) return;
        var panel = panelFor(picked);
        var select = $('[data-dl-pathselect]');
        var apply = $('#dl-apply');
        if (select && panel) {
          select.value = panel.getAttribute('data-form-value') || '';
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        selectPartner(picked, true);
        if (apply) apply.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
      });
    }
  }

  /* ---------------- assortment planner ---------------- */
  var planner = $('[data-dl-planner]');
  if (planner) {
    var plans = $$('[data-dl-plan]', planner);
    var chanChips = $$('[data-dl-chan]', planner);

    var applyChannel = function (key, label) {
      plans.forEach(function (p) {
        $$('[data-dl-act]', p).forEach(function (card) {
          card.hidden = card.getAttribute('data-dl-act') !== key;
        });
        var lab = $('[data-dl-chlabel]', p);
        if (lab) lab.textContent = label;
      });
    };

    $$('[data-dl-aud]', planner).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var id = chip.getAttribute('data-dl-aud');
        $$('[data-dl-aud]', planner).forEach(function (c) {
          c.setAttribute('aria-pressed', String(c === chip));
        });
        plans.forEach(function (p) { p.hidden = p.getAttribute('data-dl-plan') !== id; });
      });
    });

    chanChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chanChips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        applyChannel(chip.getAttribute('data-dl-chan'), chip.textContent.trim());
      });
    });
  }

  /* ---------------- application form ---------------- */
  var apply = $('[data-dl-apply]');
  if (!apply) return;

  var STORAGE = 'kiwiDealerDraftV1';

  // Success render → the application is delivered; the draft has done its job.
  if ($('[data-dl-success]', apply)) {
    try { localStorage.removeItem(STORAGE); } catch (_) {}
    return;
  }

  var form = $('#dl-form', apply);
  if (!form) return;

  var steps = $$('[data-dl-step]', form);
  var jumps = $$('[data-dl-jump]', form);
  var track = $('[data-dl-track]', form);
  var btnBack = $('[data-dl-back]', form);
  var btnSave = $('[data-dl-save]', form);
  var btnNext = $('[data-dl-next]', form);
  var btnSubmit = $('[data-dl-submit]', form);
  var msg = $('[data-dl-msg]', form);
  var review = $('[data-dl-review]', form);
  var TOTAL = steps.length;
  var current = 1;
  var maxVisited = 1;

  /* checkbox groups → one clean comma-joined contact[...] line each */
  var mirror = function () {
    $$('[data-dl-mirror]', form).forEach(function (hidden) {
      var group = hidden.getAttribute('data-dl-mirror');
      var vals = $$('input[name="' + group + '"]:checked', form).map(function (i) { return i.value; });
      hidden.value = vals.join(', ');
    });
  };

  var getValues = function () {
    var data = {};
    $$('input, select, textarea', form).forEach(function (c) {
      if (!c.name || c.type === 'hidden' || c.type === 'submit') return;
      if (c.type === 'checkbox' || c.type === 'radio') {
        if (!(c.name in data)) data[c.name] = [];
        if (c.checked) data[c.name].push(c.value);
      } else {
        data[c.name] = c.value;
      }
    });
    return data;
  };

  var saveDraft = function (announce) {
    try {
      localStorage.setItem(STORAGE, JSON.stringify({ data: getValues(), current: current, maxVisited: maxVisited, savedAt: new Date().toISOString() }));
      if (announce) {
        msg.textContent = 'Draft saved in this browser.';
        msg.style.color = 'var(--color-kiwi-ink, #0C8149)';
        setTimeout(function () { if (/Draft saved/.test(msg.textContent)) { msg.textContent = ''; msg.style.color = ''; } }, 2500);
      }
    } catch (_) {
      if (announce) msg.textContent = 'This browser could not save the draft locally.';
    }
  };

  var restoreDraft = function () {
    var payload = null;
    try { payload = JSON.parse(localStorage.getItem(STORAGE)); } catch (_) { return; }
    if (!payload || !payload.data) return;
    Object.keys(payload.data).forEach(function (name) {
      var value = payload.data[name];
      $$('[name="' + name.replace(/"/g, '\\"') + '"]', form).forEach(function (c) {
        if (c.type === 'checkbox' || c.type === 'radio') {
          c.checked = Array.isArray(value) && value.indexOf(c.value) !== -1;
        } else if (!Array.isArray(value)) {
          c.value = value;
        }
      });
    });
    current = Math.min(TOTAL, Math.max(1, Number(payload.current) || 1));
    maxVisited = Math.min(TOTAL, Math.max(current, Number(payload.maxVisited) || current));
  };

  var saveTimer;
  var debounceSave = function () {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () { saveDraft(false); }, 450);
  };

  var counter = $('[data-dl-count]', form);
  var planField = form.querySelector('[name="contact[body]"]');
  var updateCount = function () {
    if (counter && planField) counter.textContent = String(planField.value.length);
  };

  var stepEl = function (n) {
    return steps.filter(function (s) { return Number(s.getAttribute('data-dl-step')) === n; })[0];
  };

  var wrapperOf = function (control) {
    var w = control.closest('.dl-field, .dl-choice, .dl-consent');
    return w;
  };

  var validateStep = function (n) {
    var section = stepEl(n);
    if (!section || section.hidden && n === TOTAL) return true;
    var valid = true;
    var firstBad = null;
    $$('input, select, textarea', section).forEach(function (c) {
      if (c.type === 'hidden') return;
      var w = wrapperOf(c);
      if (!w) return;
      var ok = true;
      if (c.willValidate && !c.checkValidity()) ok = false;
      if (c.required && !c.value.trim() && c.type !== 'checkbox' && c.type !== 'radio') ok = false;
      if (!ok) {
        w.classList.add('invalid');
        valid = false;
        if (!firstBad) firstBad = c;
      }
    });
    // choice groups: at least one checked when any input in the group is required-flavoured
    $$('.dl-choice', section).forEach(function (group) {
      var inputs = $$('input', group).filter(function (i) { return i.type === 'checkbox' || i.type === 'radio'; });
      if (!inputs.length) return;
      var mustPick = inputs.some(function (i) { return i.required; }) || group.hasAttribute('data-dl-group');
      if (!mustPick) return;
      var picked = inputs.some(function (i) { return i.checked; });
      group.classList.toggle('invalid', !picked);
      if (!picked) { valid = false; if (!firstBad) firstBad = inputs[0]; }
    });
    // consent
    $$('.dl-consent input[type="checkbox"]', section).forEach(function (c) {
      var bad = c.required && !c.checked;
      var err = $('[data-dl-consenterr]', section);
      c.closest('.dl-consent').classList.toggle('invalid', bad);
      if (err) err.classList.toggle('dl-err--on', bad);
      if (bad) { valid = false; if (!firstBad) firstBad = c; }
    });
    if (!valid) {
      msg.textContent = 'Please complete the highlighted fields before continuing.';
      if (firstBad) firstBad.focus({ preventScroll: false });
    } else {
      msg.textContent = '';
    }
    return valid;
  };

  var buildReview = function () {
    if (!review) return;
    review.textContent = '';
    steps.slice(0, TOTAL - 1).forEach(function (section) {
      var head = section.querySelector('h3');
      var wrap = document.createElement('section');
      var h = document.createElement('h4');
      h.className = 'dl-revtitle';
      h.textContent = head ? head.textContent : '';
      wrap.appendChild(h);
      var rows = document.createElement('dl');
      rows.className = 'dl-revrows';
      var addRow = function (label, value) {
        var dt = document.createElement('dt');
        dt.textContent = label;
        var dd = document.createElement('dd');
        dd.textContent = value || 'Not provided';
        rows.appendChild(dt);
        rows.appendChild(dd);
      };
      $$('.dl-field', section).forEach(function (field) {
        var labelEl = field.querySelector(':scope > span');
        var control = field.querySelector('input, select, textarea');
        if (!labelEl || !control) return;
        var label = labelEl.textContent.replace(/\s*\*\s*$/, '').trim();
        var value = control.value;
        if (control.tagName === 'SELECT') {
          var opt = control.options[control.selectedIndex];
          value = control.value ? (opt ? opt.textContent : control.value) : '';
        }
        addRow(label, value.trim());
      });
      $$('.dl-choice', section).forEach(function (group) {
        var legend = group.querySelector('legend');
        if (!legend) return;
        var vals = $$('input:checked', group).map(function (i) { return i.value; });
        addRow(legend.textContent.replace(/\s*\*\s*$/, '').trim(), vals.join(', '));
      });
      wrap.appendChild(rows);
      review.appendChild(wrap);
    });
  };

  var show = function (n, scroll) {
    current = Math.min(TOTAL, Math.max(1, n));
    maxVisited = Math.max(maxVisited, current);
    if (current === TOTAL) { mirror(); buildReview(); }
    steps.forEach(function (s) {
      s.hidden = Number(s.getAttribute('data-dl-step')) !== current;
    });
    jumps.forEach(function (b, i) {
      var stepN = i + 1;
      b.disabled = stepN > maxVisited;
      b.setAttribute('aria-current', stepN === current ? 'step' : 'false');
      b.classList.toggle('dl-jump--done', stepN < current);
    });
    if (track) track.style.width = String(((current - 1) / (TOTAL - 1)) * 100) + '%';
    btnBack.hidden = false;
    btnBack.disabled = current === 1;
    btnNext.hidden = current === TOTAL;
    btnSubmit.hidden = current !== TOTAL;
    if (scroll) {
      var y = form.getBoundingClientRect().top + window.pageYOffset - 110;
      window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
      var first = $('[data-dl-step="' + current + '"] input, [data-dl-step="' + current + '"] select, [data-dl-step="' + current + '"] textarea', form);
      setTimeout(function () { if (first) first.focus({ preventScroll: true }); }, reduced ? 0 : 400);
    }
  };

  /* ---- arm the stepper ---- */
  form.noValidate = true;
  $('[data-dl-progress]', form).hidden = false;
  btnSave.hidden = false;
  btnNext.hidden = false;
  var draftCard = $('[data-dl-draftcard]', apply);
  if (draftCard) draftCard.hidden = false;

  restoreDraft();
  mirror();
  updateCount();
  show(current, false);

  btnNext.addEventListener('click', function () {
    if (!validateStep(current)) return;
    show(current + 1, true);
    saveDraft(false);
  });
  btnBack.addEventListener('click', function () { show(current - 1, true); });
  btnSave.addEventListener('click', function () { saveDraft(true); });
  jumps.forEach(function (b) {
    b.addEventListener('click', function () {
      var target = Number(b.getAttribute('data-dl-jump'));
      if (target > maxVisited || target === current) return;
      show(target, true);
    });
  });

  form.addEventListener('input', function (e) {
    var w = e.target.closest && e.target.closest('.dl-field, .dl-choice, .dl-consent');
    if (w) w.classList.remove('invalid');
    if (e.target === planField) updateCount();
    debounceSave();
  });
  form.addEventListener('change', function (e) {
    var w = e.target.closest && e.target.closest('.dl-field, .dl-choice, .dl-consent');
    if (w) w.classList.remove('invalid');
    mirror();
    debounceSave();
  });

  form.addEventListener('submit', function (e) {
    for (var n = 1; n < TOTAL; n++) {
      if (!validateStep(n)) {
        e.preventDefault();
        show(n, true);
        return;
      }
    }
    mirror();
    saveDraft(false);
    btnSubmit.disabled = true;
    var label = btnSubmit.querySelector('span') || btnSubmit;
    btnSubmit.setAttribute('data-dl-sent', '1');
    label.textContent = 'Sending…';
  });
})();
